import axios from 'axios'

/**
 * Thin wrapper around POST /realtime/token and POST /realtime/token/upgrade on
 * the Edaptio API. Both mint a credential for Edaptio's realtime service,
 * `{ url, token, expires_at }`, where `token` lists the channels the user may
 * subscribe to (signed server-side).
 */
export default {
    /**
     * Mint a baseline token for the logged-in user. Channels: user:<id>,
     * group:<g> for each group, institution:<i>, plus group:<g>:submissions /
     * :quiz-attempts / :teachers for groups they admin.
     */
    async issueToken() {
        const { data } = await axios.post('/realtime/token')
        return { realtime: data.realtime }
    },

    /**
     * Mint an upgraded token that additionally grants board:<id>.
     * 403 if the user can't access the resource.
     */
    async issueUpgradedToken(type, id) {
        const { data } = await axios.post('/realtime/token/upgrade', { type, id })
        return { realtime: data.realtime }
    },
}
